import http from '../../../../api/axios';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../../../../api/apiUrl';
import { Values } from '../../../../forms/Team/TeamForm.types';
import { handleApiErrors } from '../../../../api/apiErrorHandler';
import { TeamForm } from '../../../../forms/Team/TeamForm';
import { toast } from 'react-toastify';
import { paths } from '../../../RouterContainer';
import { useTranslation } from '../../../../context/translationContext';
import { useEffect } from 'react';
import { useBreadcrumbs } from '../../../../hooks/useBreadcrumbs';
import { useLoading } from '../../../../context/loadingContext';

/**
 * Page component represents Teams overview for current user
 */
export const UserTeamsCreatePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_TEAMS}`,
        name: 'navigation.my-teams',
      },
      {
        path: `${paths.MY_TEAMS}/create`,
        name: 'navigation.my-teams-create',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () => navigate(`/${paths.MY_TEAMS}`);

  /**
   * Handles create action.
   * Uses team create API. Redirects to edit page of created entity.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPost({ url: apiUrl.TEAM_CREATE, data: values });
      if (response?.status === 201) {
        stopLoading();
        toast.success('Success!');
        navigate(`/${paths.MY_TEAMS}/edit/${response?.data.id}`, { state: response?.data.id });
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <>
      <h1 className="text-3xl font-bold">{t('page.team.new-team')}</h1>
      <TeamForm onSubmit={handleSubmit} onBack={handleOnBack} />
    </>
  );
};
